import { LocationMarkerIcon, StarIcon } from "@heroicons/react/solid";

function Product({
  img,
  title,
  price,
  city = "Sukoharjo",
  discount,
  rating,
  className,
}) {
  return (
    <div
      className={`relative flex flex-col bg-white rounded-lg shadow-md m-2 p-2 cursor-pointer border-t ${className}`}
    >
      <img src={img} alt="" className="object-contain h-52" />
      <h1 className="line-clamp-2 text-sm">{title}</h1>
      {discount && (
        <div className="flex items-center space-x-2 my-auto">
          <div className="bg-red-200 text-red-500 p-2 rounded-md text-xs font-bold w-8 h-5 flex items-center">
            50%
          </div>
          <div className="line-through text-xs text-gray-400">Rp. {price}</div>
        </div>
      )}
      <p className="my-auto font-bold text-gray-800">Rp. {price}</p>
      <div className="flex space-x-1 mt-auto items-center">
        <LocationMarkerIcon className="text-tokped_green h-5" />
        <p className="text-xs text-gray-400">{city}</p>
      </div>
      {rating && (
        <div className="flex items-center space-x-1 my-auto">
          <StarIcon className="text-yellow-400 h-5" />
          <p className="border-r pr-2 border-gray-300 text-xs text-gray-400">
            {rating.rate}
          </p>
          <p className="text-xs text-gray-400 pl-1">Terjual</p>
          <p className="text-xs text-gray-400">{rating.count}</p>
        </div>
      )}
    </div>
  );
}

export default Product;
